import HometownGroupsContainer from './HometownGroupsContainer';

export default HometownGroupsContainer;
